var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpand({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.1818 11.8182H7.40911C7.57652 11.8182 7.71685 11.8744 7.83011 11.9868C7.94337 12.0992 8 12.2385 8 12.4046C8 12.5708 7.94337 12.7115 7.83011 12.8269C7.71685 12.9423 7.57652 13 7.40911 13H3.73078C3.52373 13 3.35018 12.93 3.21011 12.7899C3.07004 12.6498 3 12.4763 3 12.2692V8.59089C3 8.42348 3.0562 8.28314 3.16861 8.16989C3.28101 8.05663 3.42028 8 3.58643 8C3.75259 8 3.89335 8.05663 4.00873 8.16989C4.12411 8.28314 4.1818 8.42348 4.1818 8.59089V11.8182ZM11.8182 4.1818H8.59089C8.42348 4.1818 8.28314 4.1256 8.16989 4.01321C8.05663 3.90081 8 3.76154 8 3.59539C8 3.42924 8.05663 3.28847 8.16989 3.17309C8.28314 3.0577 8.42348 3 8.59089 3H12.2692C12.4763 3 12.6498 3.07004 12.7899 3.21011C12.93 3.35018 13 3.52373 13 3.73078V7.40911C13 7.57652 12.9438 7.71685 12.8314 7.83011C12.719 7.94337 12.5797 8 12.4136 8C12.2474 8 12.1066 7.94337 11.9913 7.83011C11.8759 7.71685 11.8182 7.57652 11.8182 7.40911V4.1818Z",
    fill: "#717C8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.261c7fad28af823c67b869c435d56e9b.svg";
export { ForwardRef as ReactComponent };